import { ACCOUNT_MENU_TASK } from './accountMenu';
import { AUTOMATION_FLOW_TASK } from './automationFlow';
import { CREATE_FORM_TASK } from './createForm';
import { NEW_CAMPAIGNS_MODULE_TASK } from './newCampaignsModule';
import { SOCIAL_MEDIA_POST_TASK } from './socialMediaPost';
import { validateTaskFlows, type TaskFlow } from './types';
import { WORKSPACE_SWITCHER_TASK } from './workspaceSwitcher';

export const TASKS: TaskFlow[] = [
  WORKSPACE_SWITCHER_TASK,
  NEW_CAMPAIGNS_MODULE_TASK,
  SOCIAL_MEDIA_POST_TASK,
  AUTOMATION_FLOW_TASK,
  CREATE_FORM_TASK,
  ACCOUNT_MENU_TASK,
];

export function getTaskForStep(stepId: string | null | undefined): TaskFlow | null {
  if (!stepId) return null;
  return TASKS.find((task) => task.stepId === stepId) ?? null;
}

export function getTask(taskId: string): TaskFlow | null {
  return TASKS.find((task) => task.id === taskId) ?? null;
}

export function validateTasks(): string[] {
  return validateTaskFlows(TASKS);
}

export {
  ACCOUNT_MENU_TASK,
  AUTOMATION_FLOW_TASK,
  CREATE_FORM_TASK,
  NEW_CAMPAIGNS_MODULE_TASK,
  SOCIAL_MEDIA_POST_TASK,
  WORKSPACE_SWITCHER_TASK,
};
export type { TaskFlow, TaskStep, CalloutSide } from './types';
